import * as types from './shopListActionTypes';
import {
  SearchMode,
  SearchParams,
  FilterState,
  Shop,
  CurrentLocation,
  FilterOption,
  AreaOption,
} from '../../../pages/ShopList/types';

// 検索モード設置
export const setSearchMode = (mode: SearchMode) => ({
  type: types.SET_SEARCH_MODE,
  payload: mode,
});

// 検索パラメータ設置
export const setSearchParams = (params: SearchParams) => ({
  type: types.SET_SEARCH_PARAMS,
  payload: params,
});

// フィルター条件設置
export const setFilters = (filters: FilterState) => ({
  type: types.SET_FILTERS,
  payload: filters,
});

// フィルター条件クリア
export const clearFilters = () => ({
  type: types.CLEAR_FILTERS,
});

// 店舗リスト取得リクエスト
export const fetchShopsRequest = () => ({
  type: types.FETCH_SHOPS_REQUEST,
});

export const fetchShopsSuccess = (shops: Shop[], totalCount: number) => ({
  type: types.FETCH_SHOPS_SUCCESS,
  payload: { shops, totalCount },
});

export const fetchShopsFailure = (error: string) => ({
  type: types.FETCH_SHOPS_FAILURE,
  payload: error,
});

export const initalShopsList = () => ({
  type: types.FETCH_SHOPS_INITIAL,
});

// お気に入り登録
export const toggleBookmark = (shopId: string) => ({
  type: types.TOGGLE_BOOKMARK,
  payload: shopId,
});

export const toggleBookmarkSuccess = (shopId: string, isBookmarked: boolean) => ({
  type: types.TOGGLE_BOOKMARK_SUCCESS,
  payload: { shopId, isBookmarked },
});

export const toggleBookmarkFailure = (error: string) => ({
  type: types.TOGGLE_BOOKMARK_FAILURE,
  payload: error,
});

export const setSelectedShop = (shopId: string | null, isAnnexSelected: boolean) => ({
  type: types.SET_SELECTED_SHOP,
  payload: { shopId, isAnnexSelected },
});

// 現在位置取得
export const fetchCurrentLocation = () => ({
  type: types.FETCH_CURRENT_LOCATION,
});

export const setCurrentLocation = (location: CurrentLocation) => ({
  type: types.SET_CURRENT_LOCATION,
  payload: location,
});

// フィルターオプション取得
export const fetchFilterOptions = () => ({
  type: types.FETCH_FILTER_OPTIONS,
});

export const fetchFilterOptionsSuccess = (facilities: FilterOption[], services: FilterOption[]) => ({
  type: types.FETCH_FILTER_OPTIONS_SUCCESS,
  payload: { facilities, services },
});

export const fetchFilterOptionsFailure = (error: string) => ({
  type: types.FETCH_FILTER_OPTIONS_FAILURE,
  payload: error,
});

// エリアオプション取得
export const fetchAreaOptions = () => ({
  type: types.FETCH_AREA_OPTIONS,
});

export const fetchAreaOptionsSuccess = (areas: AreaOption[]) => ({
  type: types.FETCH_AREA_OPTIONS_SUCCESS,
  payload: areas,
});

export const fetchAreaOptionsFailure = (error: string) => ({
  type: types.FETCH_AREA_OPTIONS_FAILURE,
  payload: error,
});
